// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__NuMFO","emails":"CreateEditClinics_emails__MKoP4","emailTagLabel":"CreateEditClinics_emailTagLabel__xKxAM"};